import React, { useState, useCallback, useEffect, forwardRef } from 'react';
import { styled } from '@mui/joy/styles';
import Grid from '@mui/joy/Grid';
import Sheet from '@mui/joy/Sheet';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';

import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Input from '@mui/joy/Input';
import IconTrash from '../../assets/icons/trash.svg'
import IconButton from '@mui/joy/IconButton';
import IconPlus from '../../assets/icons/Plus.svg'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import EditIcon from '@mui/icons-material/Edit';

//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';



/////////////////////API
import { getStates, deleteStates, createStates, updateStates } from '../../Api/Statistics';

const schema = yup.object({
  statistics: yup.array(yup.object({
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),
    content_en: yup.string().required("هذا الحقل مطلوب"),
  }))
})



const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function StatisticsComponent() {
  const [loading, setLoading] = useState(false)
  const [openAlert, setOpenAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');

  const [openAlertError, setOpenAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState('');

  const form = useForm({
    defaultValues: {
      title_ar: "",
      title_en: "",
      content_ar: "",
      content_en: "",
      statistics: []
    },
    resolver: yupResolver(schema)
  });
  const { register, handleSubmit, formState, setValue, trigger, getValues, watch, clearErrors } = form;
  const { errors } = formState
  const statistics = watch('statistics')

  const openNewStatistic = () => {

    setValue('statistics', [...statistics, {}])
    clearErrors()
  }

  const deleteStatistic = async (id, index) => {
    if(statistics.at(index).id) {
      const res = await deleteStates(id);
      if (res) {
        setMessageAlert('تم الحذف بنجاح')
        setOpenAlert(true)
        listStates();
      }
    }else{
      const updatedTotalStatistics = [
        ...statistics.slice(0, index),
        ...statistics.slice(index + 1)
      ];
      setValue('statistics', updatedTotalStatistics)
    }

  };

  const listStates = useCallback(async () => {
    const res = await getStates();
    if (res) {
      setValue('statistics', res)
    }
  }, []);

  const checkCreateStatistic = async (index) => {
    const res = await trigger()
    if(res){
      setValue(`statistics.${index}.content_ar`, statistics.at(index).content_en)
      const resApi = await createStates(statistics.at(index))
      if (resApi) {
        setMessageAlert('تم الاضافة بنجاح')
        setOpenAlert(true)
        listStates();
      }
    }
  };

  const checkEditStatistic = async (index) => {
    const res = await trigger()
    if(res){
      setValue(`statistics.${index}.content_ar`, statistics.at(index).content_en)
      const resApi = await updateStates(statistics.at(index).id, statistics.at(index))
      if (resApi) {
        setMessageAlert('تم التعديل بنجاح')
        setOpenAlert(true)
        listStates();
      }
    }
  }

  const handleClick = () => {
    setOpenAlert(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const handleCloseAlertError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlertError(false);
  };


  useEffect(() => {
    listStates();
  }, [listStates])

  return (
    <>
      <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
        <Alert severity="success">{messageAlert}</Alert>
      </Snackbar>

      <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
        <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
          {messageAlertError}
        </Alert>
      </Snackbar>
      {statistics.map((statistic, index) => {
        return (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            alignItems='center'
            sx={{ width: '100%' }}
            key={index}
          >
            <Grid xs={9}>
              <Box component="section" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormControl sx={{ width: '40%' }}>
                  <FormLabel>الإحصائية</FormLabel>
                  <Input
                    placeholder="عدد السيارات المقيمة"
                    sx={{ borderRadius: '20px' }}
                    value={statistic.title_ar}
                    {...register(`statistics.${index}.title_ar`)}
                  />
                  {errors.statistics?.at(index)?.title_ar &&
                    <Typography
                      color="danger"
                      level="body-xs"
                      variant="plain"
                    >{errors.statistics[index]?.title_ar?.message}</Typography>
                  }
                </FormControl>

                <FormControl sx={{ width: '40%', direction: 'ltr' }}>
                  <FormLabel>Statistics</FormLabel>
                  <Input
                    placeholder="Statistics"
                    sx={{ borderRadius: '20px' }}
                    value={statistic.title_en}
                    {...register(`statistics.${index}.title_en`)}
                  />
                  {errors.statistics?.at(index)?.title_en &&
                    <Typography
                      color="danger"
                      level="body-xs"
                      variant="plain"
                    >{errors.statistics[index]?.title_en?.message}</Typography>
                  }
                </FormControl>

                <FormControl sx={{ width: '15%' }}>
                  <FormLabel>الرقم</FormLabel>
                  <Input
                    placeholder="0"
                    sx={{ borderRadius: '20px' }}
                    value={statistic.content_en}
                    {...register(`statistics.${index}.content_en`)}

                  />
                  {errors.statistics?.at(index)?.content_en &&
                    <Typography
                      color="danger"
                      level="body-xs"
                      variant="plain"
                    >{errors.statistics[index]?.content_en?.message}</Typography>
                  }
                </FormControl>
              </Box>
            </Grid>
            <Grid xs={3} sx={{ display: 'flex', justifyContent: 'flex-end', height: '40px' }}>
              <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => deleteStatistic(statistic.id, index)}>
                <img src={IconTrash} alt='trash icon' />
              </IconButton>
              {statistics.length - 1 == index && statistic.id && (
                <>
                  <IconButton variant='plain' sx={{ height: '40px' }} onClick={openNewStatistic}>
                    <img src={IconPlus} alt='trash icon' />
                  </IconButton>
                </>
              )}


              {!statistic.id ? (
                <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => checkCreateStatistic(index)}>
                  <CheckBoxIcon sx={{ color: '#3E64F4', fontSize: '35px' }} />
                </IconButton>
              ) : (
                <IconButton variant='plain' sx={{ height: '40px' }} onClick={() => checkEditStatistic(index)}>
                  <EditIcon sx={{background:'#185EA5', borderRadius:'50%', padding:'5px 5px', color:'#FFF'}}/>
                </IconButton>
              )}
            </Grid>
          </Grid>
        )
      })}
    </>
  )
}